import React, { useEffect } from "react";

const GoogleTranslate = () => {
  useEffect(() => {
    // Define the Google Translate initialization function
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages:
            "en,hi,mr,af,ar,as,bn,zh-CN,fr,de,gu,id,hu,it,ja,kn,ks,ko,ms,ml,mn,ne,pl,pa,ru,sa,sd,es,sv,ta,te,tr,uk,ur,vi,ga",
          //   layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        "google_translate_element"
      );
    };

    // Load the Google Translate JavaScript file
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.body.appendChild(script);

    // Cleanup function
    return () => {
      document.body.removeChild(script);
      delete window.googleTranslateElementInit;
    };
  }, []);

  return <div id="google_translate_element"></div>;
};

export default GoogleTranslate;
